import React, { Fragment } from 'react';

const IS_MAC = window !== undefined && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
export const Cmd = () => <Fragment>{IS_MAC ? '⌘' : 'Ctrl'}</Fragment>;
